import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { Color, FontSize, Screen } from 'styles';

const SmallButtonStyle = css`
  padding: 19px 20px;
`;

export const StyledElementButton = styled(Link)`
  background-color: ${Color.Black};
  color: ${Color.White};
  display: inline-block;
  font-size: ${FontSize.S};
  text-align: center;
  position: relative;
  padding: 19px 34px;
  
  transition: color 300ms;
  transform: translateZ(0);
  backface-visibility: hidden;
  
  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${Color.Orange};
    transform: scaleX(1);
    transform-origin: 50%;
    transition-property: transform;
    transition: 300ms ease-out;
  }
  &:hover:before {
    transform: scaleX(0);
  }
  
  ${Screen.small(SmallButtonStyle)}
`;


// WEBPACK FOOTER //
// ./src/utils/styledElements/button/button.style.js